const card = {
  columnsCount: {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4,
  },
  // '' means "no brand opinion — keep each surface's stock corners".
  // brandCardRadius applies any value a partner theme sets here verbatim,
  // including an explicit '0' (force truly square).
  borderRadius: '',
};

export default card;
